/**
 * Поддержка: жалобы и публичный статус (§П5.2, §П5.5).
 */

import type { SupportCategory } from "@hive/shared";

import { apiFetch } from "./client.js";

export type GeoStatsPayload = {
  readonly pointCount: number;
  readonly avgAccuracyM: number;
  readonly quarantineRatio: number;
  readonly avgBatchIntervalMs: number;
};

export type SupportReportContext = {
  readonly hexId?: string;
  readonly ledgerEntryId?: number;
  readonly siegeId?: string;
};

export type ClientErrorPayload = {
  readonly code: string;
  readonly at: string;
};

export type SubmitSupportReportInput = {
  readonly category: SupportCategory;
  readonly message: string;
  readonly clientVersion: string;
  readonly clientPlatform: string;
  readonly locale: string;
  readonly context?: SupportReportContext;
  readonly clientErrors?: readonly ClientErrorPayload[];
  readonly geoStats?: GeoStatsPayload;
};

export type SupportReportResult = {
  readonly reportId: string;
  readonly replayed: boolean;
};

export type ServiceComponentState = "ok" | "degraded" | "down" | "unknown";

export type ServiceStatusView = {
  readonly updatedAt: string;
  readonly version: string;
  readonly components: {
    readonly api: ServiceComponentState;
    readonly database: ServiceComponentState;
    readonly accrual: ServiceComponentState;
  };
  readonly incidents: ReadonlyArray<{
    readonly id: string;
    readonly severity: "minor" | "major" | "critical";
    readonly code: string;
    readonly startedAt: string;
    readonly resolvedAt?: string;
  }>;
};

export async function fetchServiceStatus(signal?: AbortSignal): Promise<ServiceStatusView> {
  return apiFetch<ServiceStatusView>("/status", signal ? { signal } : {});
}

export async function submitSupportReport(
  input: SubmitSupportReportInput,
  token: string,
  idempotencyKey: string,
): Promise<SupportReportResult> {
  return apiFetch<SupportReportResult>("/support/report", {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify(input),
  });
}
